export default __webpack_public_path__ + "static/media/about_icon4hover.0417badf.svg";